import type { CardInViewProps } from "./card-in-view.type";

import { Flex, Typography } from "antd";

const { Title } = Typography;

import "./card-in-view.style.less";

/**
 * CardInView keep header and footer in the viewport using sticky mode.
 */
export const CardInView = ({
  title,
  headerActions,
  footerActions,
  children,
}: CardInViewProps) => {
  return (
    <Flex vertical gap={24} className="card-in-view">
      <Flex gap="large" className="card-in-view-header">
        <Title level={2} className="card-in-view-title">
          {title}
        </Title>
        <Flex gap="small">{headerActions}</Flex>
      </Flex>
      {children}
      <Flex gap="medium" className="card-in-view-footer">
        {footerActions}
      </Flex>
    </Flex>
  );
};
